export default __webpack_public_path__ + "static/media/exicitingNewFeatures.68cefdfd.png";